import { useTranslation } from "react-i18next";
import { PERMISSIONS } from "../../const/permissions.const";

interface IProps {
    permission: PERMISSIONS;
}

export function NoPermission(props: IProps) {
    const { t } = useTranslation();
    return <div>
        <p> {t(`snackbar.permissions.failure.${props.permission}`)} </p>
    </div>
}